import { featuresData } from '@/mocks/homeData';

const iconBgColors = [
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-600',
  'bg-secondary-100 text-secondary-600',
  'bg-primary-100 text-primary-600',
  'bg-accent-100 text-accent-600',
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-shield-star-line"></i>
            <span>平台优势</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择女神漫画
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            五大核心优势，打造极致的漫画在线阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featuresData.slice(0, 3).map((feat, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 hover:-translate-y-1 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${iconBgColors[idx]}`}>
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mt-4 md:mt-6 max-w-4xl mx-auto">
          {featuresData.slice(3).map((feat, idx) => (
            <div
              key={idx + 3}
              className="bg-background-100 rounded-xl p-5 md:p-6 hover:-translate-y-1 transition-all duration-200 cursor-pointer flex items-start gap-4"
            >
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${iconBgColors[idx + 3]}`}>
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}